import React, { useState } from 'react';
import { Button } from '../UI/Button';
interface ApplicationFormProps {
  onFormSubmit: () => void;
}
export const ApplicationForm = ({
  onFormSubmit
}: ApplicationFormProps) => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    location: '',
    role: '',
    experience: '',
    pastExperience: '',
    motivation: '',
    hours: '',
    linkedin: '',
    instagram: '',
    facebook: '',
    twitter: '',
    hasAttendedEvent: '',
    eventAttended: '',
    notes: '',
    consent: false
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const handleChange = e => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };
  const handleSubmit = async e => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    try {
      const response = await fetch('https://formspree.io/f/xanppkda', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        setFormData({
          fullName: '',
          email: '',
          phone: '',
          location: '',
          role: '',
          experience: '',
          pastExperience: '',
          motivation: '',
          hours: '',
          linkedin: '',
          instagram: '',
          facebook: '',
          twitter: '',
          hasAttendedEvent: '',
          eventAttended: '',
          notes: '',
          consent: false
        });
        // Call the parent component's callback to show the thank you page
        onFormSubmit();
      } else {
        throw new Error('Failed to submit form');
      }
    } catch (err) {
      setError('There was an error submitting your application. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <div className="bg-white p-6 rounded-lg border-2 border-gray-200" data-id="element-688">
      <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-689">
        The Networking Salon — Team Application (Contract Roles)
      </h3>
      <p className="text-gray-600 mb-6" data-id="element-690">
        We're excited that you're interested in joining The Networking Salon!
        Please fill out this short form carefully. It helps us learn about your
        experience, interests, and how you can contribute to our growing
        community.
      </p>
      <p className="text-gray-600 mb-6" data-id="element-691">
        These are contract-based roles (3–6 months, renewable) — part-time,
        remote or hybrid, and performance/commission-based.
      </p>
      {error && <div className="bg-red-50 border border-red-200 text-red-800 p-4 rounded-md mb-6" data-id="element-692">
          {error}
        </div>}
      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-693">
        <div className="space-y-4" data-id="element-694">
          <div data-id="element-695">
            <label htmlFor="fullName" className="block text-gray-700 font-medium mb-1" data-id="element-696">
              Full Name
            </label>
            <input type="text" id="fullName" name="fullName" value={formData.fullName} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-697" />
          </div>
          <div data-id="element-698">
            <label htmlFor="email" className="block text-gray-700 font-medium mb-1" data-id="element-699">
              Email Address
            </label>
            <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-700" />
          </div>
          <div data-id="element-701">
            <label htmlFor="phone" className="block text-gray-700 font-medium mb-1" data-id="element-702">
              Phone Number (WhatsApp Preferred)
            </label>
            <input type="text" id="phone" name="phone" value={formData.phone} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-703" />
          </div>
          <div data-id="element-704">
            <label htmlFor="location" className="block text-gray-700 font-medium mb-1" data-id="element-705">
              City & State of Residence
            </label>
            <input type="text" id="location" name="location" value={formData.location} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-706" />
          </div>
          <div data-id="element-707">
            <label className="block text-gray-700 font-medium mb-1" data-id="element-708">
              Have you ever attended any of The Networking Salon events?
            </label>
            <div className="space-y-2" data-id="element-709">
              {['Yes', 'No'].map(option => <div key={option} className="flex items-center" data-id="element-710">
                  <input type="radio" id={`hasAttendedEvent-${option}`} name="hasAttendedEvent" value={option} checked={formData.hasAttendedEvent === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-711" />
                  <label htmlFor={`hasAttendedEvent-${option}`} className="text-gray-700" data-id="element-712">
                    {option}
                  </label>
                </div>)}
            </div>
          </div>
          {formData.hasAttendedEvent === 'Yes' && <div data-id="element-713">
              <label className="block text-gray-700 font-medium mb-1" data-id="element-714">
                Which event(s) did you attend? (Select all that apply)
              </label>
              <select name="eventAttended" value={formData.eventAttended} onChange={handleChange} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-715">
                <option value="" data-id="element-716">Select an event</option>
                <option value="Abuja" data-id="element-717">Abuja</option>
                <option value="Port Harcourt" data-id="element-718">Port Harcourt</option>
                <option value="Benin" data-id="element-719">Benin</option>
                <option value="Lagos" data-id="element-720">Lagos</option>
                <option value="Warri" data-id="element-721">Warri</option>
                <option value="Berlin" data-id="element-722">Berlin</option>
                <option value="Houston Texas" data-id="element-723">Houston Texas</option>
                <option value="Virtual Coffee Chat" data-id="element-724">Virtual Coffee Chat</option>
                <option value="Other" data-id="element-725">Other</option>
              </select>
            </div>}
          <div data-id="element-726">
            <label className="block text-gray-700 font-medium mb-1" data-id="element-727">
              Which role are you applying for?
            </label>
            <div className="space-y-2" data-id="element-728">
              {['Community & Programs Lead', 'Content & Communications Lead', 'Tech & Systems Support'].map(option => <div key={option} className="flex items-center" data-id="element-729">
                  <input type="radio" id={`role-${option}`} name="role" value={option} checked={formData.role === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-730" />
                  <label htmlFor={`role-${option}`} className="text-gray-700" data-id="element-731">
                    {option}
                  </label>
                </div>)}
            </div>
          </div>
          <div data-id="element-732">
            <label className="block text-gray-700 font-medium mb-1" data-id="element-733">
              Have you played this role before or done something similar?
            </label>
            <div className="space-y-2" data-id="element-734">
              {['Yes, I have experience in this exact role', "I've done something similar",, "I'm new to this but eager to learn"].map(option => <div key={option} className="flex items-center" data-id="element-735">
                  <input type="radio" id={`experience-${option}`} name="experience" value={option} checked={formData.experience === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-736" />
                  <label htmlFor={`experience-${option}`} className="text-gray-700" data-id="element-737">
                    {option}
                  </label>
                </div>)}
            </div>
          </div>
          <div data-id="element-738">
            <label htmlFor="pastExperience" className="block text-gray-700 font-medium mb-1" data-id="element-739">
              Briefly describe your past experience or related work
              <span className="block text-sm text-gray-500" data-id="element-740">
                (Include any events, communities, or projects you've managed or
                contributed to.)
              </span>
            </label>
            <textarea id="pastExperience" name="pastExperience" value={formData.pastExperience} onChange={handleChange} required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-741" />
          </div>
          <div data-id="element-742">
            <label htmlFor="motivation" className="block text-gray-700 font-medium mb-1" data-id="element-743">
              What excites you about joining The Networking Salon team?
            </label>
            <textarea id="motivation" name="motivation" value={formData.motivation} onChange={handleChange} required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-744" />
          </div>
          <div data-id="element-745">
            <label className="block text-gray-700 font-medium mb-1" data-id="element-746">
              How many hours a week can you commit to this role?
            </label>
            <div className="space-y-2" data-id="element-747">
              {['Less than 5 hours', '5–10 hours', '10–15 hours', 'More than 15 hours'].map(option => <div key={option} className="flex items-center" data-id="element-748">
                  <input type="radio" id={`hours-${option}`} name="hours" value={option} checked={formData.hours === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-749" />
                  <label htmlFor={`hours-${option}`} className="text-gray-700" data-id="element-750">
                    {option}
                  </label>
                </div>)}
            </div>
          </div>
          <div data-id="element-751">
            <label className="block text-gray-700 font-medium mb-3" data-id="element-752">
              Social Media Links (for reference & engagement)
            </label>
            <div className="space-y-3" data-id="element-753">
              <div data-id="element-754">
                <label htmlFor="linkedin" className="block text-gray-600 text-sm mb-1" data-id="element-755">
                  LinkedIn Profile
                </label>
                <input type="text" id="linkedin" name="linkedin" value={formData.linkedin} onChange={handleChange} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-756" />
              </div>
              <div data-id="element-757">
                <label htmlFor="instagram" className="block text-gray-600 text-sm mb-1" data-id="element-758">
                  Instagram Handle
                </label>
                <input type="text" id="instagram" name="instagram" value={formData.instagram} onChange={handleChange} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-759" />
              </div>
              <div data-id="element-760">
                <label htmlFor="facebook" className="block text-gray-600 text-sm mb-1" data-id="element-761">
                  Facebook Profile
                </label>
                <input type="text" id="facebook" name="facebook" value={formData.facebook} onChange={handleChange} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-762" />
              </div>
              <div data-id="element-763">
                <label htmlFor="twitter" className="block text-gray-600 text-sm mb-1" data-id="element-764">
                  X (Twitter) Handle
                </label>
                <input type="text" id="twitter" name="twitter" value={formData.twitter} onChange={handleChange} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-765" />
              </div>
            </div>
          </div>
          <div data-id="element-766">
            <label htmlFor="notes" className="block text-gray-700 font-medium mb-1" data-id="element-767">
              Any other notes or message for us?
            </label>
            <textarea id="notes" name="notes" value={formData.notes} onChange={handleChange} rows={3} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-768" />
          </div>
          <div className="pt-2" data-id="element-769">
            <div className="flex items-start" data-id="element-770">
              <input type="checkbox" id="consent" name="consent" checked={formData.consent} onChange={handleChange} required className="mr-2 mt-1 h-4 w-4 border-2 border-gray-300" data-id="element-771" />
              <label htmlFor="consent" className="text-gray-700" data-id="element-772">
                I confirm that the information I've provided is accurate and
                that I understand this is a part-time, contract-based
                opportunity with performance-linked compensation.
              </label>
            </div>
          </div>
        </div>
        <div className="pt-2" data-id="element-773">
          <Button type="submit" disabled={isSubmitting} className="w-full py-3" data-id="element-774">
            {isSubmitting ? 'Submitting...' : 'Submit Application'}
          </Button>
        </div>
      </form>
    </div>;
};